import client from './RestClient';
import { AxiosInstance } from 'axios';
import {
  BrandOption,
  OutBound,
  OutBoundKeyword,
  OutBoundApiResponse,
  BrandApiResponse,
  MaxCvrBrandApiResponse,
  CnCodeOption,
  CnCodeApiResponse,
  RecommendBrandApiResponse,
} from '../core/brand/Brand';
import { Iprops } from '../core/brand/BrandManager';

export interface BrandWebService {
  getBrandOptions(): Promise<BrandOption[]>;
  getOutSideBrands(props: Iprops): Promise<OutBound[]>;
  getCnCodeOptions(webBrandNo: string): Promise<CnCodeOption[]>;
  getMaxCvrBrandOptions(): Promise<BrandOption[]>;
  getRecommendBrandOptions(): Promise<BrandOption[]>;
  getOutBoundKeywordBrand(): Promise<OutBoundKeyword[]>;
}

export class RestfulBrandWebService implements BrandWebService {
  restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getBrandOptions(): Promise<BrandOption[]> {
    const response = await this.restClient.get<BrandApiResponse>(
      `/v2/creatives/brand-names`,
    );
    const options = response.data.entpBrandNames.map(
      ({
        brandName,
        webBrandNo,
        floorDailyBudget,
        ceilingDailyBudget,
        floorCPC,
        ceilingCPC,
      }) => ({
        label: brandName,
        value: webBrandNo,
        floorDailyBudget: floorDailyBudget,
        ceilingDailyBudget: ceilingDailyBudget,
        floorCPC: floorCPC,
        ceilingCPC: ceilingCPC,
      }),
    );
    return options;
  }

  async getCnCodeOptions(webBrandNo: string): Promise<CnCodeOption[]> {
    const response = await this.restClient.get<CnCodeApiResponse>(
      `/v2/creatives/${webBrandNo}/category-info`,
    );
    const options = response.data.categoryInfoList.map(
      ({ categoryName, categoryCode }) => ({
        label: categoryName,
        value: categoryCode,
      }),
    );
    return options;
  }

  async getMaxCvrBrandOptions(): Promise<BrandOption[]> {
    const response = await this.restClient.get<MaxCvrBrandApiResponse>(
      `/v2/creatives/getSmartKeywordEntpBrand`,
    );
    const options = response.data.records.map(({ brandName, webBrandNo }) => ({
      label: brandName,
      value: webBrandNo,
    }));
    return options;
  }

  async getRecommendBrandOptions(): Promise<BrandOption[]> {
    const response = await this.restClient.get<RecommendBrandApiResponse>(
      `/v2/agencies/recommend-smart-brands`,
    );
    const options = response.data.map(({ brandName, webBrandNo }) => ({
      label: brandName,
      value: webBrandNo,
    }));
    return options;
  }

  async getOutSideBrands(props: Iprops): Promise<OutBound[]> {
    const { campaignAdType, goodsId } = props;
    const response = await this.restClient.get<OutBoundApiResponse>(
      `/v2/campaigns/outbound/brands?campaign-ad-type=${campaignAdType}&goods-id=${goodsId}`,
    );
    console.log('response out', response);
    const options =
      response.data.records?.map((item) => ({
        webBrandNo: item.webBrandNo,
        brandName: item.brandName,
        label: item.brandName,
        value: item.webBrandNo,
        logoUrl: item.logoUrl,
        available: item.available,
      })) || [];
    return options;
  }

  async getOutBoundKeywordBrand(): Promise<OutBoundKeyword[]> {
    const response = await this.restClient.get<OutBoundApiResponse>(
      `v2/campaigns/outbound/outbound-keywords-brands`,
    );
    console.log('response', response);
    const options =
      response.data.records?.map((item) => ({
        webBrandNo: item.id?.webBrandNo,
        brandName: item.brandName,
        label: item.brandName,
        value: item.id?.webBrandNo,
        logoUrl: item.logoUrl,
      })) || [];
    return options;
  }
}
